import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { getNotificationIcon } from './notifications';
import './notification.scss';

const NotificationToast = ({ alert }) => {
  const senderName = [alert?.fName, alert?.lName].filter(Boolean).join(' ');

  return (
    <div className="notification-toast">
      <div className="notification-toast-icon">
        <FontAwesomeIcon icon={getNotificationIcon(alert)} />
      </div>

      <div className="notification-toast-content">
        {senderName && <span className="notification-toast-sender">{senderName}</span>}
        <span className="notification-toast-subject mt-2">{alert?.message || alert?.subject}</span>
      </div>
    </div>
  );
};

NotificationToast.propTypes = {
  alert: PropTypes.shape({
    fName: PropTypes.string,
    lName: PropTypes.string,
    subject: PropTypes.string,
    message: PropTypes.string
  }).isRequired
};

export default NotificationToast;
